import { graphql } from '../gql'

export const GET_HEADER_QUERY = graphql(`
  query GetHeader($code: String, $id: ID) {
    getHeader(code: $code, id: $id) {
      id
      code
      navLinks {
        label
        active
        link {
          label
          type
          openInNewTab
          url
          linkRef
        }
        children {
          label
          active
          type
          openInNewTab
          url
          linkRef
        }
      }
    }
  }
`)
